<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_Quot_FinishDates' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='txQuotFinishDates-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'quotCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txQuotFinishDates')">{{ scope.row.quotCode }}</a>
                </span>
              <span v-else>
                <span v-if="item.key=== 'finishDate'">{{ scope.row[item.key] | dateFormats }}</span>
                <span
                  v-else-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txQuotFinishDates-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txQuotFinishDates-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp">
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as txQuotFinishDates from '@/api/tx_quot_finishdates';
import mytable from '@/utils/crmtableFlowV2';
import * as txQuots from '@/api/tx_quots';

export default {
  name: 'txQuotFinishDates',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_Quot_FinishDate',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return txQuotFinishDates;
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnPass':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条数据',
              type: 'error'
            });
            return;
          } else {
            this.Pass();
          }
          break;
        case 'btnPassNo':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条数据',
              type: 'error'
            });
            return;
          } else {
            this.PassNo();
          }
          break;
      }
    },
    PassNo() {
      this.$confirm('是否要不通过审核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.state === '审核中');
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(','),
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txQuotFinishDates.AuditNotThrough(paramStr).then(res => {
            this.$message({
              message: '审核不通过',
              type: 'success'
            });
            this.getList();
          }).catch((_) => {
          });
        } else {
          this.$message({
            message: '请选择状态为审核中的数据!',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },
    Pass() {
      this.$confirm('是否要审核通过', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.state === '审核中');
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(','),
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txQuotFinishDates.Approved(paramStr).then(res => {
            this.$message({
              message: '审核通过',
              type: 'success'
            });
            this.getList();
          }).catch((_) => {
          });
        } else {
          this.$message({
            message: '请选择状态为审核中的数据!',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },

    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txQuotFinishDates') {
        const paramStr = JSON.stringify({
          keyValue: row.quotId,
          fromPlan: 0
        });
        txQuots.get(paramStr).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_quotsview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txQuotFinishDates-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

</style>
